var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('Loading',{attrs:{"loading":_vm.isLoading}}),_c('router-view'),_c('LoginDialog',{attrs:{"value":!_vm.isLogin.access_token || _vm.loginDialog}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }